import { AppProductLine as ProductLine } from 'graphql/models/extended';

export function isProductLine(value: unknown): value is ProductLine {
  return Boolean(
    typeof value === 'object'
      && (value as ProductLine).product
  );
}
